import ResponsiveTypography from '@/components/ui/responsive-typography';
import {useTranslation} from 'react-i18next';

const SafariMatrixInfo: React.FC = () => {
  const {t} = useTranslation();

  return <ResponsiveTypography>{t('safari_matrix_info')}</ResponsiveTypography>;
};

export default SafariMatrixInfo;
